import React from 'react';
import { injectIntl } from 'react-intl';
import { InputLinedSC } from './input.styled';
import Error from '../error';

type TProps = {
  name: string;
  value: any;
  type?: string;
  placeholder?: string;
  error?: string | boolean;
  onChange(e: any): void;
  intl: any;
  skipPlaceholderTranslation?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const InputLined: React.FC<TProps> = ({
  placeholder,
  intl,
  error,
  disabled,
  readOnly,
  skipPlaceholderTranslation,
  ...props
}) => (
  <InputLinedSC error={error} disabled={readOnly}>
    <input
      {...props}
      value={props.value || ''}
      readOnly={readOnly}
      autoComplete="off"
      placeholder={
        placeholder
          ? skipPlaceholderTranslation
            ? placeholder
            : intl.formatMessage({ id: placeholder })
          : ''
      }
    />
    {readOnly ? (
      <span className="input-lined-img">
        <img src={require('../../assets/svg/icon-check-green.svg').default} alt="OK" />
      </span>
    ) : null}
    <Error message={error} />
  </InputLinedSC>
);

InputLined.defaultProps = {
  type: 'text',
};

// @ts-ignore
export default injectIntl(InputLined);
